import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import SelectWithSearch from "modules/common/components/form/SelectWithSearch";
export class SelectFilterAPI extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      loading: false,
      isLoadingMore: false,
      limit: props.limit || 20,
      options: props.options || [],
      page_no: 1,
      hasMore: true,
      search: "",
    };
    this.timer = "";
    this.getData = this.getData.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }
  getData(search, page_no = 1) {
    const { dataUrl } = this.props;
    let _this = this;
    let searchQuery = "";
    let filter = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    if (_this.props.addFilter) {
      filter = _this.props.addFilter;
    } else {
      filter = "";
    }
    if (page_no === 1) {
      _this.setState({ loading: true });
    } else {
      _this.setState({ isLoadingMore: true });
    }
    this.mAPI.sendGetAPI(
      `${dataUrl}?limit=${this.state.limit}&page_no=${page_no}${searchQuery}${filter}&orderBy=create_at&order=DESC`,
      (data) => {
        if (data && data.data) {
          let options = [];
          data.data.forEach((data) => {
            options.push({
              value: data._id,
              data: data,
              label: data.name || data.phone_number,
            });
          });
          _this.setState((prevState) => ({
            options: page_no === 1 ? options : [...prevState.options, ...options],
            loading: false,
            isLoadingMore: false,
            hasMore: data.data.length >= _this.state.limit
          }));
        } else if (data) {
          let options = [];
          data.forEach((data) => {
            options.push({
              value: data._id,
              data: data,
              label: data.name || data.phone_number,
            });
          });
          _this.setState((prevState) => ({
            options: page_no === 1 ? options : [...prevState.options, ...options],
            loading: false,
            isLoadingMore: false,
            hasMore: data.length >= _this.state.limit
          }));
        } else {
          _this.setState((prevState) => ({
            options: page_no === 1 ? [] : prevState.options,
            loading: false,
            isLoadingMore: false,
            hasMore: false
          }));
        }
      },
      (error, data) => {
        _this.setState((prevState) => ({
          options: page_no === 1 ? [] : prevState.options,
          loading: false,
          isLoadingMore: false,
          hasMore: false
        }));
      },
      this.props.global === true ? "public" : ""
    );
  }
  loadMore() {
    if (!this.state.loading && !this.state.isLoadingMore && this.state.hasMore) {
      const nextPage = this.state.page_no + 1;
      this.setState({ page_no: nextPage }, () => {
        this.getData(this.state.search, nextPage);
      });
    }
  }
  onSearch(search) {
    let _this = this;
    search = search == "reload" ? "" : search;
    clearTimeout(this.timer);
    _this.setState({ loading: true, search: search, page_no: 1 });
    _this.timer = setTimeout(() => {
      _this.getData(search, 1);
    }, 350);
  }

  componentDidMount() {
    // this.getData();
  }

  render() {
    const {
      selected,
      label,
      name,
      onSelect,
      multi,
      initialValues,
      disabled,
      placeholder,
    } = this.props;
    return (
      <SelectWithSearch
        placeholder={label}
        loading={this.state.loading}
        initialValues={initialValues}
        selectedValues={selected}
        totalOptions={this.state.options}
        label={label}
        onSelect={onSelect}
        name={name}
        search={this.onSearch}
        multi={multi}
        customOption=""
        disabled={disabled}
        showAvatar={false}
        onMenuScrollToBottom={this.loadMore}
      />
    );
  }
}
SelectFilterAPI.contextTypes = {
  __: PropTypes.func,
};

export default SelectFilterAPI;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SelectFilterAPI.js